import { useEffect } from "react";
import { Loader2 } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { TicketPanelShell } from "@sd/components/layout/TicketPanelShell";
import { ProjectsIndex } from "@sd/components/projects/ProjectsIndex";
import { useAuth } from "@sd/hooks/useAuth";
import { sd } from "@sd/lib/sdPaths";

export default function Projects() {
  const { role, isLoading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (isLoading) return;
    if (role === "ServiceDesk_Admin") {
      navigate(sd("admin/projects"), { replace: true });
    }
  }, [isLoading, navigate, role]);

  if (isLoading || role === "ServiceDesk_Admin") {
    return (
      <div className="flex h-screen items-center justify-center bg-background">
        <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" />
      </div>
    );
  }

  return (
    <TicketPanelShell activeQueue="">
      <ProjectsIndex />
    </TicketPanelShell>
  );
}
